import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NlToBrPipe } from '../../../../../../../pipes/nl-to-br.pipe';

@Component({
  selector: 'app-p0003601-en-savoir-plus',
  templateUrl: './p0003601-en-savoir-plus.component.html',
  styleUrls: ['./p0003601-en-savoir-plus.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    NlToBrPipe,
  ],
})
export class P0003601EnSavoirPlusComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
